import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-beige border-t border-brand-sand/60 text-brand-brown">
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          
          {/* Virksomhedsinfo og Mission */}
          <div className="flex flex-col gap-5">
            <Link to="/" className="inline-block focus:outline-none group" aria-label="EquiGramVet">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=90,format=auto/assets/19a97e0e-8e3c-4b11-bc4c-e5bcc52ff735/equigram-logo.png" 
                alt="EquiGramVet" 
                className="h-40 sm:h-48 md:h-56 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.02]"
              />
            </Link>
            <p className="text-sm leading-relaxed max-w-sm text-brand-brown/90">
              Professionel kiropraktik til heste og hunde. Vi skaber balance, bevægelighed og livskvalitet med fokus på faglig ro og omsorg.
            </p>
            <div className="text-xs text-brand-brown/70 mt-2">
              CVR: 46305892
            </div>
          </div>

          {/* Hurtige links */}
          <div className="flex flex-col gap-4 md:pl-8">
            <h4 className="font-serif text-base font-bold text-brand-dark tracking-wide">
              Hurtige links
            </h4>
            <nav className="flex flex-col gap-2.5 text-sm">
              <Link to="/" className="hover:text-brand-dark transition-colors duration-200">
                Forside
              </Link>
              <Link to="/kiropraktik" className="hover:text-brand-dark transition-colors duration-200">
                Kiropraktik til Heste
              </Link>
              <Link to="/kiropraktik-til-hunde" className="hover:text-brand-dark transition-colors duration-200">
                Kiropraktik til Hunde
              </Link>
              <Link to="/priser" className="hover:text-brand-dark transition-colors duration-200">
                Priser
              </Link>
              <Link to="/om-equigramvet" className="hover:text-brand-dark transition-colors duration-200">
                Om EquiGramVet
              </Link>
            </nav>
          </div>

          {/* Kontakt og Adresse */}
          <div className="flex flex-col gap-4">
            <h4 className="font-serif text-base font-bold text-brand-dark tracking-wide">
              Kontakt os
            </h4>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot text-brand-brown/80 mt-1" />
                <span className="leading-relaxed">
                  Borupvej 30, Snekkerup,<br />
                  4140 Borup
                </span>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-brand-brown/80" />
                <a 
                  href="tel:+4526992415" 
                  className="hover:text-brand-dark transition-colors duration-200 whitespace-nowrap"
                >
                  26 99 24 15
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-brand-brown/80" />
                <a 
                  href="mailto:kontakt@equigramvet.dk" 
                  className="hover:text-brand-dark transition-colors duration-200 whitespace-nowrap"
                >
                  kontakt@equigramvet.dk
                </a>
              </div>
            </div>
            <div className="mt-4 p-3 rounded bg-brand-cream/60 border border-brand-sand/50 text-xs leading-relaxed">
              <span className="font-semibold text-brand-dark block mb-1">Behandling i trygge rammer</span>
              Vi kører ud til behandlinger i hele Sjælland. Specialaftaler for resten af Danmark kan laves efter ønske.
            </div>
          </div>

        </div>

        {/* Bundlinje */}
        <div className="mt-16 pt-8 border-t border-brand-sand/40 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-brand-brown/60">
          <div>
            &copy; {currentYear} EquiGramVet. Alle rettigheder forbeholdes.
          </div>
          <div className="flex gap-6">
            <span>CVR: 46305892</span>
            <span>Borup, Danmark</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
